export default "<div class=\"third-party\">\n  <router-outlet *cygovLoader=\"isLoading\"></router-outlet>\n</div>\n"